import { UiState, HeaderMode } from './interfaces';

export const uiStateInitialState: UiState = {
  hasDirtyForm: false,
  headerMode: HeaderMode.Scorecards,
};

export const storeName = 'uiState';
